/**
 * External dependencies
 */

import React from "react";
import classNames from "classnames";
import "./styles.scss";
import { Box } from "@towersystems/towersystems-design-system";

const Main = ({
  className,
  paddingLeft = "xxlarge",
  paddingRight = "xxlarge",
  children,
  ...rest
}) => {
  const classes = classNames(className, "main");
  return (
    <Box
      component="main"
      className={classes}
      role="main"
      paddingLeft={paddingLeft}
      paddingRight={paddingRight}
      {...rest}
    >
      {children}
    </Box>
  );
};

export default Main;
